var Writaholics = Writaholics || {};

Writaholics.Logo = function () {
	var logo = $(".brand-logo");

	var _init = function () {
		_changeLogo();
	}

	var _changeLogo = function () {

		$(window).scroll(function () {
			var scroll = $(window).scrollTop();
			if (scroll >= 1) {
				logo.attr("src", "img/layout/writaholics-logo.svg").fadeIn(100);
			} else {
				logo.attr("src", "img/layout/writaholics-logo-light.svg").fadeIn(100);
			}

		});
	}

	/** PUBLIC API **/
	return {
		init: function () { return _init(); }
	};

}();

jQuery(function () {
	Writaholics.Logo.init();
});
